import React from 'react'
import styles from './PrivacyPolicy.module.css'
import { privacyData } from './PrivacyNote'
import Loader from '../common-component/Loader/Loader'
import MetaDetails from 'components/meta-details/MetaDetails'

function PrivacyPolicyTemplate({title, data}) {
  
  return (
    <>
    <MetaDetails
        title={title}
        description={"Information Policy"}
        keywords={["information policy","privacy policy"]?.join(', ')}
      />
    {!data ? <Loader /> : (
    <div className="privacy-policy">
    <div className={styles.privacyOuter}>
      <div className={styles.titleSection}>{title}</div>
      <div dangerouslySetInnerHTML={{ __html: data?.data?.content }} />
    </div>
    </div>
    )}
    </>
  )
}

export default PrivacyPolicyTemplate
